import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'
import type { IMaintenance } from '@/shared/interfaces/seigyo-config'

export const useMaintenanceStore = defineStore('maintenance', () => {
  const maintenance = reactive<IMaintenance>({
    MaintenanceModeOn: false,
    Type: 0,
    Name: '',
    EndDate: ''
  })
  const maintenanceMPC = reactive<IMaintenance>({
    MaintenanceModeOn: false,
    Type: 0,
    Name: '',
    EndDate: ''
  })

  const setMaintenance = (_maintenance: IMaintenance) => {
    maintenance.EndDate = _maintenance.EndDate
    maintenance.MaintenanceModeOn = _maintenance.MaintenanceModeOn
    maintenance.Name = _maintenance.Name
    maintenance.Type = _maintenance.Type
  }

  const setMaintenanceMPC = (_maintenance: IMaintenance) => {
    maintenanceMPC.EndDate = _maintenance.EndDate
    maintenanceMPC.MaintenanceModeOn = _maintenance.MaintenanceModeOn
    maintenanceMPC.Name = _maintenance.Name
    maintenanceMPC.Type = _maintenance.Type
  }

  return {
    maintenance,
    maintenanceMPC,
    setMaintenance,
    setMaintenanceMPC
  }
})
